module.exports = __webpack_public_path__ + "img/buyer.0265f76b.svg";